import type { EligibilityCheckView } from '../dispatch.api';

/** The Override action shows only on a block that nothing has overridden and that is not a legal rule: a warning needs no approver, and no approver may lift an expired insurance. */
export function canOfferOverride(check: EligibilityCheckView, canApprove: boolean): boolean {
  return canApprove && check.status === 'block' && !check.override && !check.nonOverridable;
}
